export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.28-1231.16",
  commitId: "e0e3a174b425aeca52193f87a87b2b92d3bddd87",
  commitTime: "2026-08-28T12:31:16.000Z",
});
